// import
import PubSub from "./PubSub";

// we only want to instantiate this class one time
const pubSub = new PubSub();

export default pubSub;
